import { FC, useEffect, useLayoutEffect } from 'react';

import Helmet from '@/components/meta/Helmet';
import GuideFlowTemplate from '@/components/templates/Guide/Flow';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

import { GuidePageTitles } from '../types';

const GuideFlowPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'ご利用ガイド',
        to: '/guide',
      },
      {
        name: 'ご利用のながれ',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: GuidePageTitles.Flow,
          description:
            'DMM競輪のご利用ガイドページ。DMM競輪の利用登録から投票、精算までの流れをご案内します。',
          keywords: `${GuidePageTitles.Flow},ご利用ガイド,%s`,
        }}
      />
      <GuideFlowTemplate />
    </>
  );
};

export default GuideFlowPage;
